import 'css-chunk:src/app/containers/Home/OrganizationsView/OrganizationDetailView.scss';export default {
  "OrganizationDetailView": "_OrganizationDetailView_e7o4j_2",
  "header": "_header_e7o4j_2",
  "action": "_action_e7o4j_7",
  "children": "_children_e7o4j_10",
  "menu": "_menu_e7o4j_10"
};